<template>
  <div class="sb-button">
    <a>
      <slot />
    </a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.sb-button {
  display: flex;
  border-radius: 10px;
  background-color: var(--coral);
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
}

.sb-button:hover {
  background-color: var(--reddish);
}

.sb-button > a {
  color: white;
}

.sb-button > a:hover {
  text-decoration: none;
}
</style>
